var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeydriveCollapsedAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.553,
    height: 17.73,
    viewBox: "0 0 26.553 17.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    "data-name": "Caminho 195",
    d: "M75.431,10.072h11.6V15.3H84.412V12.681H75.424a3.9,3.9,0,1,1,0-2.623h0Zm-3.674.02a1.284,1.284,0,1,0,1.284,1.284A1.282,1.282,0,0,0,71.757,10.093Z",
    transform: "translate(-67.85 -7.47)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_604",
    "data-name": "Grupo 604",
    transform: "translate(-46.339 -0.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_601",
    "data-name": "Grupo 601",
    transform: "translate(56.815 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M98.6,5.667A8.344,8.344,0,0,0,96.74,2.86a8.7,8.7,0,0,0-2.9-1.851A10.222,10.222,0,0,0,90.074.34H83.19V6.145h4.139V3.5h2.745a5.252,5.252,0,0,1,2.1.4,4.333,4.333,0,0,1,1.564,1.134,5.051,5.051,0,0,1,.977,1.8A7.756,7.756,0,0,1,95.06,9.2a7.847,7.847,0,0,1-.341,2.384,5.11,5.11,0,0,1-.977,1.8,4.275,4.275,0,0,1-1.564,1.134,5.252,5.252,0,0,1-2.1.4H87.329V12H83.19V18.07h6.884a10.2,10.2,0,0,0,3.763-.662,8.491,8.491,0,0,0,2.9-1.851A8.211,8.211,0,0,0,98.6,12.749,9.227,9.227,0,0,0,99.267,9.2,9.158,9.158,0,0,0,98.6,5.674Z",
    transform: "translate(-83.19 -0.34)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_602",
    "data-name": "Grupo 602",
    transform: "translate(46.339 5.109)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M75.393,11.4l-.123-.089h.123Z",
    transform: "translate(-70.202 -8.687)",
    fill: "#f99601",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M75.139,11.781l-.669-.471h.546l.123.089Z",
    transform: "translate(-69.949 -8.687)",
    fill: "#f99501",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M74.889,12.164,73.68,11.31h.54l.669.471Z",
    transform: "translate(-69.698 -8.687)",
    fill: "#f89401",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M74.635,12.539,72.88,11.31h.546l1.209.854Z",
    transform: "translate(-69.445 -8.687)",
    fill: "#f89301",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M74.382,12.922l-2.3-1.612h.546l1.755,1.229Z",
    transform: "translate(-69.191 -8.687)",
    fill: "#f89201",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M74.258,13.3l-2.568-1.8v-.2h.266l2.3,1.612Z",
    transform: "translate(-69.067 -8.687)",
    fill: "#f89101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M74.258,13.779l-2.568-1.8V11.6l2.568,1.8Z",
    transform: "translate(-69.067 -8.779)",
    fill: "#f89001",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M74,14.144,71.69,12.532V12.15l2.568,1.8v.191Z",
    transform: "translate(-69.067 -8.954)",
    fill: "#f78f01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M73.452,14.322,71.69,13.092V12.71L74,14.322Z",
    transform: "translate(-69.067 -9.131)",
    fill: "#f78e01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M72.906,14.5l-1.216-.847V13.27L73.452,14.5Z",
    transform: "translate(-69.067 -9.309)",
    fill: "#f78d01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M72.366,14.677l-.676-.471V13.83l1.216.847Z",
    transform: "translate(-69.067 -9.486)",
    fill: "#f78c01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M71.82,14.851l-.13-.089V14.38l.676.471Z",
    transform: "translate(-69.067 -9.661)",
    fill: "#f68b01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M71.69,14.94l.13.089h-.13Z",
    transform: "translate(-69.067 -9.838)",
    fill: "#f68a01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M94.212,10.078,90.51,7.49h3.7Z",
    transform: "translate(-75.034 -7.476)",
    fill: "#feb002",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M93.958,10.461,89.71,7.49h.546l3.7,2.588Z",
    transform: "translate(-74.781 -7.476)",
    fill: "#feb002",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M93.708,10.843,88.92,7.49h.54l4.248,2.971Z",
    transform: "translate(-74.53 -7.476)",
    fill: "#feaf02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M93.454,11.219,88.12,7.49h.546l4.788,3.353Z",
    transform: "translate(-74.276 -7.476)",
    fill: "#feae02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M93.2,11.6,87.33,7.49h.54L93.2,11.219Z",
    transform: "translate(-74.026 -7.476)",
    fill: "#fdad02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M92.95,11.984,86.53,7.49h.546L92.95,11.6Z",
    transform: "translate(-73.772 -7.476)",
    fill: "#fdac02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M92.7,12.366,85.73,7.49h.546l6.42,4.494Z",
    transform: "translate(-73.519 -7.476)",
    fill: "#fdab02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M92.446,12.742,84.94,7.49h.54l6.966,4.876Z",
    transform: "translate(-73.268 -7.476)",
    fill: "#fdaa02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M92.192,13.124,84.14,7.49h.546l7.506,5.252Z",
    transform: "translate(-73.015 -7.476)",
    fill: "#fda902",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M91.938,13.507,83.34,7.49h.546l8.052,5.634Z",
    transform: "translate(-72.761 -7.476)",
    fill: "#fca802",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    "data-name": "Caminho 159",
    d: "M91.688,13.889,82.55,7.49h.54l8.6,6.017Z",
    transform: "translate(-72.511 -7.476)",
    fill: "#fca702",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M91.434,14.272,81.75,7.49H82.3l9.138,6.4Z",
    transform: "translate(-72.257 -7.476)",
    fill: "#fca602",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M91.181,14.647,80.95,7.49H81.5l9.684,6.782Z",
    transform: "translate(-72.003 -7.476)",
    fill: "#fca502",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M90.93,15.03,80.16,7.49h.54L90.93,14.647Z",
    transform: "translate(-71.753 -7.476)",
    fill: "#fba402",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M90.526,15.3,79.36,7.49h.546l10.77,7.54V15.3Z",
    transform: "translate(-71.499 -7.476)",
    fill: "#fba302",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M89.73,15.3,78.57,7.49h.54L90.276,15.3Z",
    transform: "translate(-71.249 -7.476)",
    fill: "#fba202",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M88.93,15.3,77.77,7.49h.546L89.476,15.3Z",
    transform: "translate(-70.995 -7.476)",
    fill: "#fba102",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M88.136,15.3,76.97,7.49h.546L88.676,15.3Z",
    transform: "translate(-70.741 -7.476)",
    fill: "#fba002",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M87.34,15.3,76.18,7.49h.54L87.886,15.3Z",
    transform: "translate(-70.491 -7.476)",
    fill: "#fa9f02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M86.546,15.3,75.38,7.49h.546L87.086,15.3Z",
    transform: "translate(-70.237 -7.476)",
    fill: "#fa9e02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M85.746,15.3,74.58,7.49h.546L86.293,15.3Z",
    transform: "translate(-69.984 -7.476)",
    fill: "#fa9d02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M84.95,15.3,73.79,7.49h.54L85.5,15.3Z",
    transform: "translate(-69.733 -7.476)",
    fill: "#fa9c02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M84.156,15.3,72.99,7.49h.546L84.7,15.3Z",
    transform: "translate(-69.48 -7.476)",
    fill: "#fa9b02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M83.356,15.3,72.19,7.49h.546L83.9,15.3Z",
    transform: "translate(-69.226 -7.476)",
    fill: "#f99901",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M82.56,15.3,71.4,7.49h.54L83.106,15.3Z",
    transform: "translate(-68.975 -7.476)",
    fill: "#f99801",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M81.766,15.3,70.6,7.49h.546L82.306,15.3Z",
    transform: "translate(-68.722 -7.476)",
    fill: "#f99701",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M80.97,15.3,69.81,7.49h.54L81.516,15.3Z",
    transform: "translate(-68.471 -7.476)",
    fill: "#f99601",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M80.17,15.3,69.01,7.49h.546L80.716,15.3Z",
    transform: "translate(-68.218 -7.476)",
    fill: "#f99501",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M79.376,15.3,68.21,7.49h.546L79.916,15.3Z",
    transform: "translate(-67.964 -7.476)",
    fill: "#f89401",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M78.719,15.3,67.86,7.7V7.49H68.1L79.265,15.3Z",
    transform: "translate(-67.853 -7.476)",
    fill: "#f89301",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M78.18,15.4,67.86,8.182V7.8l10.859,7.6Z",
    transform: "translate(-67.853 -7.575)",
    fill: "#f89201",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M77.633,15.579,67.86,8.742V8.36l10.32,7.219Z",
    transform: "translate(-67.853 -7.752)",
    fill: "#f89101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M77.087,15.756,67.86,9.3V8.92l9.773,6.836Z",
    transform: "translate(-67.853 -7.93)",
    fill: "#f89001",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    "data-name": "Caminho 182",
    d: "M76.547,15.931,67.86,9.852V9.47l9.227,6.461Z",
    transform: "translate(-67.853 -8.104)",
    fill: "#f78f01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    "data-name": "Caminho 183",
    d: "M76,16.108l-8.141-5.7V10.03l8.687,6.078Z",
    transform: "translate(-67.853 -8.282)",
    fill: "#f78e01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M75.455,16.286,67.86,10.972V10.59L76,16.286Z",
    transform: "translate(-67.853 -8.459)",
    fill: "#f78d01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M74.915,16.463,67.86,11.526V11.15l7.595,5.313Z",
    transform: "translate(-67.853 -8.637)",
    fill: "#f78c01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M74.369,16.638,67.86,12.082V11.7l7.055,4.938Z",
    transform: "translate(-67.853 -8.811)",
    fill: "#f68b01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M73.822,16.815,67.86,12.642V12.26l6.509,4.555Z",
    transform: "translate(-67.853 -8.989)",
    fill: "#f68a01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M73.283,16.993,67.86,13.2V12.82l5.962,4.173Z",
    transform: "translate(-67.853 -9.166)",
    fill: "#f68901",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_189",
    "data-name": "Caminho 189",
    d: "M72.736,17.17,67.86,13.756V13.38l5.423,3.79Z",
    transform: "translate(-67.853 -9.344)",
    fill: "#f68801",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_190",
    "data-name": "Caminho 190",
    d: "M72.2,17.345,67.86,14.312V13.93l4.876,3.415Z",
    transform: "translate(-67.853 -9.518)",
    fill: "#f68701",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M71.65,17.522l-3.79-2.65V14.49L72.2,17.522Z",
    transform: "translate(-67.853 -9.696)",
    fill: "#f58601",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    "data-name": "Caminho 192",
    d: "M71.1,17.7,67.86,15.432V15.05l3.79,2.65Z",
    transform: "translate(-67.853 -9.873)",
    fill: "#f58501",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    "data-name": "Caminho 193",
    d: "M70.565,17.877l-2.7-1.885V15.61L71.1,17.877Z",
    transform: "translate(-67.853 -10.051)",
    fill: "#f58401",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    "data-name": "Caminho 194",
    d: "M67.86,16.17l2.7,1.885h-2.7Z",
    transform: "translate(-67.853 -10.228)",
    fill: "#f58401",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeydriveCollapsedAdmin);
export default __webpack_public_path__ + "static/media/keydrive_collapsed_admin.1921d5d306113a039d1dcbc47659da80.svg";
export { ForwardRef as ReactComponent };